<template>
  <div>
    <div
      class="notification-bar-bottom"
      v-if="showNotification && dataNotify && dataNotify[currentIndex] && systemNotify !== 'false'"
      v-bind:class="{ show: showNotification }"
    >
      <div class="notification-content d-flex">
        <p class="notification-text">
          {{ dataNotify[currentIndex] ? dataNotify[currentIndex].content : '' }}
        </p>
        <a
          v-if="dataNotify[currentIndex]"
          :href="dataNotify[currentIndex].link"
          target="_blank"
          class="link-text"
          >Xem chi tiết</a
        >
      </div>
      <button class="close-btn" @click="closeNotification">X</button>
    </div>
    <nav
      class="navbar top-navbar navbar-expand is-sticky navbar-z-index"
      v-bind:class="{ 'toggle-navbar-area': isOpen }"
    >
      <div class="collapse navbar-collapse" id="navbarSupportContent">
        <div
          class="responsive-burger-menu d-block d-lg-none"
          v-bind:class="{ active: isOpenMobile }"
          @click="$emit('toggle-sidebar-mobile')"
        >
          <span class="top-bar"></span>
          <span class="middle-bar"></span>
          <span class="bottom-bar"></span>
        </div>

        <div class="navbar-nav left-nav align-items-center">
          <div class="nav-item">
            <div class="form-search">
              <div class="company-name">
                <p>Phần mềm Quản lý Nội bộ - My NextPay v3.0.0</p>
              </div>
            </div>
          </div>
        </div>
        <callio></callio>
        <ul class="navbar-nav right-nav align-items-center">
          <ExportFile />
          <Notification v-if="!platform" />
          <b-dropdown class="no-after dropdown profile-nav-item pr-3" variant="link">
            <template #button-content>
              <div class="menu-profile">
                <span class="name fonsize-12">{{ dataUser.name }}</span>
                <img src="../../assets/img/avatar1.png" class="rounded-circle" alt="image" />
              </div>
            </template>
            <b-dropdown-item>
              <div
                class="dropdown-header d-flex flex-column align-items-center"
                style="width: 200px"
              >
                <div class="figure mb-3">
                  <img src="../../assets/img/avatar1.png" class="rounded-circle" alt="image" />
                </div>

                <div class="info text-center">
                  <span class="name text-center" style="width: 100%">{{ dataUser.name }}</span>
                  <div class="mb-3 email">{{ dataUser.username }}</div>
                </div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item v-if="isSSO != 1">
              <div class="dropdown-body">
                <ul class="profile-nav p-0">
                  <li class="nav-item">
                    <a href="#" class="nav-link pl-0" @click="$router.push('/change-pass')">
                      <i class="bx bxs-key"></i>
                      <div class="content">
                        <span class="d-block pl-4">Đổi mật khẩu</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </b-dropdown-item>
            <b-dropdown-item>
              <div class="dropdown-footer" style="margin-top: -10px">
                <ul class="profile-nav">
                  <li class="nav-item" @click="logout">
                    <a href="#" class="nav-link pl-1">
                      <span class="sub-img">
                        <img src="../../assets/img/logout.svg" alt="logout" class="drop-ft-img" />
                      </span>
                      <p class="pl-4 color-707070">Đăng xuất</p>
                    </a>
                  </li>
                </ul>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
  import callio from './Header/callio'
  import Notification from '@/components/Notification'
  import ExportFile from '@/components/ExportFile'
  import { CommonService } from '../../services/common.service'

  export default {
    name: 'Header',
    components: {
      callio,
      Notification,
      ExportFile,
    },

    data() {
      return {
        isSSO: localStorage.getItem('isSSO'),
        systemNotify: false,
        dataUser: JSON.parse(localStorage.getItem('userData')) ?? {},
        showNotification: true,
        currentIndex: 0,
        intervalId: null,
        dataNotify: [],
        platform: null,
      }
    },
    props: {
      headerbg: String,
      isOpen: Boolean,
      isOpenMobile: Boolean,
    },
    created() {
      this.systemNotify = localStorage.getItem('system-notify')
      this.getNotification()
      if (this.dataNotify) {
        this.startInterval()
      }
      this.platform = localStorage.getItem('platform')
    },
    destroyed() {
      this.stopInterval()
    },
    methods: {
      async logout() {
        await this.$store.dispatch('user/clear')
        await this.$store.dispatch('role/clear')
        await this.$store.dispatch('auth/logout')
      },
      closeNotification() {
        this.showNotification = false
        this.systemNotify = false
        localStorage.setItem('system-notify', 'false')
      },
      openNotification() {
        this.showNotification = true
      },
      async getNotification() {
        try {
          const response = await CommonService.getNotification()
          if (response.code === 1000 && response.data) {
            this.dataNotify = response.data
            if (this.systemNotify === true) {
              this.openNotification()
            }
          }
        } catch (error) {
          console.log(error)
        }
      },
      startInterval() {
        this.intervalId = setInterval(() => {
          this.showNextNotification()
        }, 3000)
      },
      stopInterval() {
        clearInterval(this.intervalId)
      },
      showNextNotification() {
        if (this.dataNotify) {
          this.currentIndex++
          if (this.currentIndex >= (this.dataNotify?.length || 0)) {
            this.currentIndex = 0
          }
        }
      },
    },
  }
</script>

<style scoped>
  .app-header {
    left: 210px;
    width: 100%;
    padding-top: 0px;
    padding-bottom: 0;
    height: 52px;
    background: #0b62ab !important;
    padding-left: 10px;
    padding-right: 10px;
  }
  .menu-profile {
    transform: translate(1rem, 0);
  }
  .dropdown .dropdown-toggle::after {
    display: none !important;
  }
  .notification-bar-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #f5d76e;
    color: #333;
    padding: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1000;
  }
  .close-btn {
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: #333;
  }
  .notification-content {
    margin: 0 auto;
    align-items: center;
    font-size: 14px;
  }

  .link-text {
    padding-left: 5px;
    font-weight: bold;
    text-decoration: underline !important;
    cursor: pointer;
  }
</style>
